module.exports = __webpack_public_path__ + "static/media/26UNRWA17.f74a79dc.jpg";